
// Vue
import {Options, Vue} from "vue-class-component";

@Options({})
export default class AdministratorPlayersNavigationVue extends Vue {}
